/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {ICONS} from "@res/icons";
import {Route_Base, Route_Messages} from "../../Routes";
import {LeftPanelSection} from "./LeftPanelSection";
import {getTabPermissions} from "@modules/utils";
import {TabPermissions} from "@app/app-shared/permission";
import {ChatsContext} from "./messages/ChatsContext";

export const MessagingPanel = () => {
    const tabPermissions = getTabPermissions();
    const routeKeys = [Route_Messages];
    if (tabPermissions === TabPermissions.MESSAGES)
        routeKeys.unshift(Route_Base);

    return <ChatsContext.Consumer>
        {({chats}) =>
            <LeftPanelSection
                icon={ICONS.icon_communication}
                routeKeys={routeKeys}
                title={"Messages"}
                showDot={Object.values(chats || {}).reduce((sum, chat) => sum + chat.unreadCount, 0) > 0}/>
        }
    </ChatsContext.Consumer>;
}
